import type { ComponentType, SVGProps } from "react"
import { CancelledIcon, CheckIcon, CogsIcon, FailedIcon } from "@/assets"
import {
  TRANSACTION_STATUS,
  type ITransactionStatus
} from "@/store/apis/withdrawalAPI"

type IBadgeModifier = "inProcess" | "success" | "failed" | "cancelled"

interface ITransactionStatusMeta {
  labelKey: string
  badgeClassName: IBadgeModifier
  BadgeIcon?: ComponentType<SVGProps<SVGSVGElement>>
}

export const STATUS_META: Record<ITransactionStatus, ITransactionStatusMeta> = {
  [TRANSACTION_STATUS.IN_PROCESS]: {
    labelKey: "wallet.withdraw.history.status.inProcess",
    badgeClassName: "inProcess",
    BadgeIcon: CogsIcon
  },
  [TRANSACTION_STATUS.SUCCESSFULLY]: {
    labelKey: "wallet.withdraw.history.status.successfully",
    badgeClassName: "success",
    BadgeIcon: CheckIcon
  },
  [TRANSACTION_STATUS.FAILED]: {
    labelKey: "wallet.withdraw.history.status.failed",
    badgeClassName: "failed",
    BadgeIcon: FailedIcon
  },
  [TRANSACTION_STATUS.CANCELLED]: {
    labelKey: "wallet.withdraw.history.status.cancelled",
    badgeClassName: "cancelled",
    BadgeIcon: CancelledIcon
  }
}
